module.exports = __webpack_public_path__ + "static/media/play2.8b47d75d.svg";